export default __webpack_public_path__ + "static/media/enProceso.d0317483.svg";